import { render, staticRenderFns } from "./Mp4Player.vue?vue&type=template&id=fcbaa9b0&scoped=true"
import script from "./Mp4Player.vue?vue&type=script&lang=js"
export * from "./Mp4Player.vue?vue&type=script&lang=js"
import style0 from "./Mp4Player.vue?vue&type=style&index=0&id=fcbaa9b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbaa9b0",
  null
  
)

export default component.exports